// extracted by mini-css-extract-plugin
export default {"table_wrapper":"NutritionalValue_table_wrapper__XUZAk","table_item":"NutritionalValue_table_item__0hn35"};